import React, { Component } from 'react';
import './style.css';
import SearchBar from '../../CommonComponents/SearchBar';
import SearchIcon from '../../assets/icons/search.svg';
import FilledArrow from '../../assets/icons/arrow_filled.svg';

class MultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      nodeListData: [],
      selectedNodename: [],
      selectednodeId: [],
      nodeId: [],
      searchFilter: '',
      selectednodeDetails: [],
      selectednodeIdDetails: [],
    };
    this.handleClick = this.handleClick.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.searchText = this.searchText.bind(this);
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      nodeListData: nextProps.options,
      nodeId: nextProps.value,
      selectednodeDetails: nextProps.nodeDetails,
      selectednodeIdDetails: nextProps.nodeIdDetails,
    });
  }
  setWrapperRef(node) {
    this.wrapperRef = node;
  }
  handleClickOutside(ev) {
    if (this.wrapperRef && !this.wrapperRef.contains(ev.target)) {
      document.getElementsByClassName('sn-dropdown-content-node')[0].style.display =
        'none';
    }
  }

  nodeClick(ev, key) {
    var classElem = key.target.parentNode.getElementsByClassName('active');

    if (classElem.length > 0) {
      document
        .getElementsByClassName('checkbox-elem  nodeId-container')
        [ev].getElementsByClassName('checkbox')[0]
        .classList.remove('active');
    } else {
      document
        .getElementsByClassName('checkbox-elem  nodeId-container')
        [ev].getElementsByClassName('checkbox')[0]
        .classList.add('active');
    }
  }

  handleChange(ev) {
    var classElem = ev.target.parentNode.getElementsByClassName('active');

    if (classElem.length > 0) {
      ev.target.classList.remove('active');
    } else {
      ev.target.classList.add('active');
    }
  }
  searchText(val) {
    this.setState(
      {
        searchFilter: val,
      },
      () => {
        // console.log(this.state.searchFilter);
      }
    );
  }
  get nodeOption() {
    const searchTerm = this.state.searchFilter.toLowerCase();
    return this.state.nodeListData.filter(
      (option) => option.toLowerCase().indexOf(searchTerm) >= 0
    );
  }

  handleClick() {
    document.querySelector('.sn-dropdown-content-node').style.display = 'none';
    var elem = document.getElementById('checkboxElements').childNodes;

    var selectedname = [];
    var nodeId = [];

    for (var i = 0; i < elem.length; i++) {
      var activeClass = elem[i].getElementsByClassName('active');
      if (activeClass.length > 0) {
        var node = elem[i].getElementsByClassName('sf-nodeName')[0].innerText; //already commented
        var val = elem[i].getAttribute('data-userId');
        selectedname.push(node);
        nodeId.push(val); //already commented
      }
    }

    this.setState(
      {
        selectedNodename: selectedname,
        selectednodeId: nodeId,
      },
      () => {
        this.props.selectNodeList(this.state.selectedNodename, this.state.selectednodeId);
      }
    );
  }

  onModal = () => {
    this.setState({ open: !this.state.open });
  };
  handleError = () => {
    console.log('No node added');
  };

  render() {
    const { open } = this.state;
    return (
      <div id='sn-dropdown'>
        <div
          style={{ borderRadius: '12px' }}
          onClick={this.state.nodeListData.length > 0 ? this.onModal : this.handleError}>
          <div className='node-selected clickable ext'>
            {this.state.selectednodeDetails.length === 0
              ? 'Select Nodes'
              : this.state.selectednodeDetails.length === 1
              ? 'Selected 1 Node'
              : 'Select Nodes'}
            <img src={FilledArrow} alt='dropdown' />
          </div>
        </div>
        <div className='m-con'></div>
        {
          <div
            className='sn-dropdown-content-node'
            ref={this.setWrapperRef}
            style={{ display: open ? 'block' : 'none' }}>
            <SearchBar
              placeholder={'Search nodes'}
              icon={SearchIcon}
              importedImg={'yes'}
              serchText={this.searchText}
            />
            <div className='sn-scrollable-element checkbox-container'>
              <div
                id='checkboxElements'
                style={{ height: '100%', overflow: 'auto', 'overflow-x': 'hidden' }}>
                {this.nodeOption &&
                  this.nodeOption.map((elem, key) => {
                    return (
                      <div
                        id='checkbox-elem-click'
                        className='checkbox-elem  nodeId-container'
                        key={key}
                        data-userId={this.state.nodeId[key]}>
                        {this.state.selectednodeDetails.indexOf(elem) > -1 ? (
                          <span
                            className='checkbox active'
                            onClick={this.handleChange.bind(this)}></span>
                        ) : (
                          <span
                            className='checkbox'
                            onClick={this.handleChange.bind(this)}></span>
                        )}

                        <span
                          className='sf-nodeName'
                          title={elem}
                          onClick={this.nodeClick.bind(this, key)}>
                          {elem}
                        </span>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className='sn-doneNodeBtn-container'>
              <button
                type='button'
                className='node-done-button'
                onClick={this.handleClick}>
                Done
              </button>
            </div>
          </div>
        }
      </div>
    );
  }
}
export default MultiSelect;
